<template>
  <div class="modal nextContract" id="nextContract">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-0 p-0">
        <div class="text-start" role="alert">
          <div class="modal-header border-0 d-flex align-items-start p-4">
            <h3 class="text-start"><strong>{{title}}</strong>
            </h3>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="p-3 pt-0">
            <p>
              {{ message }}
            </p>
            <div class="d-flex justify-content-end">
              <button v-if="startProposalAccepted && !loadProposal" @click="handleSendProposal()" type="button" class="btn button-continue border-0 fw-bold h-auto" >
                <span>Confirmar</span>
              </button>
              <button v-if="isLoading" type="button" class="btn button-continue border-0 fw-bold h-auto">
                <span  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Confirmar
              </button>
              <button  v-if="sendedEmail" type="button" class="btn button-continue border-0 fw-bold h-auto btn-close-modal " data-bs-dismiss="modal" aria-label="Close"  >
                <span>Concluir</span>
              </button>
            </div>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: "ModalConfirmProposal",
  props: {
    isLoading: Boolean,
  },
  data(){
    return {
      isEmailSent: false,
      title: 'Prosseguir para pagamento',
      message: 'Ao clicar em ‘Confirmar’, você receberá um e-mail com um link para pagamento.'
    }
  },
  computed: {
    ...mapGetters(['accepted']),
    startProposalAccepted() {
      return this.accepted === false && this.isEmailSent === false
    },
    sendedEmail(){
      return this.isEmailSent === true || this.accepted === true
    },
    loadProposal(){
      return this.isLoading === true && this.isEmailSent === false
    }

  },
  methods:{
    handleSendProposal() {
      this.$emit('proposal-accepted');
      setTimeout(() => {
        this.isEmailSent = true;
        this.title = 'Verifique o seu e-mail';
        this.message = 'Os dados para o pagamento de sua proposta foram enviados para o seu endereço de e-mail.';
      }, 5000)

    },
  },
};

</script>
<style scoped>
.button-continue {
  background: #19C1CE;
  color: #212429;
  border-radius: 2px !important;
}

.button-continue:hover {
  width: auto;
  background:#3BE5EB!important;
  border-radius: 2px !important;
  font-weight: bolder;
  height: auto;
  color:  #212429;
}

.modal-content {
  width: 80vw;
  max-width: 600px;
  max-height: 80vh;
}

@media screen and (max-width: 720px) {
  .modal-content {
    height: auto !important; 
    width: 90vw;
    padding: 1rem; 
  }
}

</style>